import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { MapPin } from "lucide-react";
import { motion } from "framer-motion";

export default function BranchNavbar() {
  const [Cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/get_list_locations"
      );
      const cityList = response.data.data;
      setCities(cityList);

      // Highlight first city
      if (cityList.length > 0) {
        setSelectedCity(cityList[0].id);
      }
    };

    fetchData();
  }, []);

  return (
    <div
      className="w-100 py-4"
      style={{ backgroundColor: "#f8f9fa" }}
    >
      <div
        className="d-flex gap-3 justify-content-center px-3"
        style={{
          overflowX: "auto",
          whiteSpace: "nowrap",
          scrollbarWidth: "none",
        }}
      >
        {Cities.map((branch, index) => {
  const isActive = index === 0; // Always highlight first item: "BRANCHES"

  return (
    <motion.div
      key={index}
      whileHover={{ y: -4 }}
      whileTap={{ scale: 0.97 }}
      className="px-2"
      style={{ display: "inline-block", marginBottom: "8px" }}
    >
      <button
        onClick={() => console.log(branch.city)}
        className="premium-branch-card"
        style={{
          background: isActive
            ? "linear-gradient(135deg, #d1f5e8, #b4f0d2)"
            : "rgba(255,255,255,0.7)",
          backdropFilter: "blur(10px)",
          padding: "12px 20px",
          borderRadius: "16px",
          border: "none",
          boxShadow: isActive
            ? "0 6px 16px rgba(0, 150, 90, 0.25)"
            : "0 3px 8px rgba(0,0,0,0.12)",
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
          gap: "12px",
        }}
      >
        <div
          style={{
            background: isActive ? "#198754" : "#ffffff",
            color: isActive ? "#fff" : "#198754",
            width: "40px",
            height: "40px",
            borderRadius: "12px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
          }}
        >
          <svg width="20" height="20" fill="currentColor">
            <path d="M12 2C8.1 2 5 5.1 5 9c0 5.2 7 13 7 13s7-7.8 7-13c0-3.9-3.1-7-7-7zM12 11.5c-1.4 0-2.5-1.1-2.5-2.5S10.6 6.5 12 6.5s2.5 1.1 2.5 2.5S13.4 11.5 12 11.5z"/>
          </svg>
        </div>

        <div>
          <h6
            style={{
              margin: 0,
              fontWeight: "600",
              color: isActive ? "#0f5132" : "#000",
            }}
          >
            {branch.city}
          </h6>
        </div>
      </button>
    </motion.div>
  );
})}

      </div>
    </div>
  );
}
